import { AuthClient } from '@micro-frontend-react/employee-experience/lib/AuthClient';
import { TelemetryClient } from '@micro-frontend-react/employee-experience/lib/TelemetryClient';
import { HttpClient } from '@micro-frontend-react/employee-experience/lib/HttpClient';
import { GraphClient } from '@micro-frontend-react/employee-experience/lib/GraphClient';
import { Shell } from '@micro-frontend-react/employee-experience/lib/Shell';
import { withStore } from '@micro-frontend-react/employee-experience/lib/withStore';
import { StoreBuilder } from '@micro-frontend-react/employee-experience/lib/StoreBuilder';
import { ReducerRegistry } from '@micro-frontend-react/employee-experience/lib/ReducerRegistry';
import { pagesReducer, pagesReducerName } from './Redux/Pages/reducer';
import persistConfig from './Services/persistConfig';
import persistConfigDynamic from './Services/persistConfigDynamic';
import persistReducer from 'redux-persist/lib/persistReducer';
import dynamicReducer from './Redux/dynamicReducer';

const telemetryClient = new TelemetryClient({
  instrumentationKey: __INSTRUMENTATION_KEY__,
  UTPConfig: __UTP_CONFIG__,
  defaultProperties: {
    appName: __APP_NAME__,
  },
});
const authClient = new AuthClient(
  {
    auth: {
      clientId: __CLIENT_ID__,
      redirectUri: window.location.origin,
      authority: 'https://login.microsoftonline.com/72f988bf-86f1-41af-91ab-2d7cd011db47',
    },
  },
  telemetryClient
);

const httpClient = new HttpClient(telemetryClient, authClient);
const graphClient = new GraphClient(httpClient);

const reducerRegistry = new ReducerRegistry().register(pagesReducerName, pagesReducer);
const persistedDynamicReducer = persistReducer(persistConfigDynamic, dynamicReducer);
reducerRegistry.register('dynamic', persistedDynamicReducer);
const appName = '__APP_NAME__';
const storeResult = new StoreBuilder(reducerRegistry, {})
  .configureLogger(__IS_DEVELOPMENT__)
  .configureSaga({ telemetryClient, authClient, httpClient, graphClient, appName })
  .configurePersistor(persistConfig)
  .build();

export const ShellWithStore = withStore(storeResult)(Shell);
